import React from 'react'

const SideLogsIcon = (
  <>
    <path
      d="M1.25016 6.16602H18.7502C18.9802 6.16602 19.1668 6.35268 19.1668 6.58268V7.41602C19.1668 7.64602 18.9802 7.83268 18.7502 7.83268H1.25016C1.02016 7.83268 0.833496 7.64602 0.833496 7.41602V6.58268C0.833496 6.35268 1.02016 6.16602 1.25016 6.16602Z"
      fill="#333333"
      fillOpacity="0.5"
    />
    <path
      d="M1.25016 0.333008H18.7502C18.9802 0.333008 19.1668 0.519675 19.1668 0.749675V1.58301C19.1668 1.81301 18.9802 1.99967 18.7502 1.99967H1.25016C1.02016 1.99967 0.833496 1.81301 0.833496 1.58301V0.749675C0.833496 0.519675 1.02016 0.333008 1.25016 0.333008Z"
      fill="#333333"
      fillOpacity="0.5"
    />
    <path
      d="M1.25016 12H9.5835C9.8135 12 10.0002 12.1867 10.0002 12.4167V13.25C10.0002 13.48 9.8135 13.6667 9.5835 13.6667H1.25016C1.02016 13.6667 0.833496 13.48 0.833496 13.25V12.4167C0.833496 12.1867 1.02016 12 1.25016 12Z"
      fill="#333333"
      fillOpacity="0.5"
    />
  </>
)

export default SideLogsIcon
